<template>
  <div class="header">
    <div class="portrait">
      <img :src="image">
    </div>
    <div class="title">
      {{ name }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'OpusHeader',
    props: {
      title: String,
      image: String
    },
    computed: {
      name() {
        return '《' + this.title + '》'
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~stylus/variable.styl'

  .header
    display: flex
    line-height: $height-header
    height $height-header
    background: $color-background-header
    align-items center
    .portrait
      height 32px
      margin-left 10px
      img
        height 32px
        width 32px
        border-radius: 50%
    .title
      flex: 1
      height 32px
      line-height 32px
      margin-left 8px
      margin-right 4px
      color $color-light-text
</style>
